module.exports = __webpack_public_path__ + "static/media/gmdm.8ac1f54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/es/gmdm.png
// module id = 130
// module chunks = 0